/**
 * Udział części w całości — jedno miejsce dla całego ekranu wyjazdu.
 *
 * Każda liczba na tym ekranie jest ułamkiem sumy, która bywa zerowa: wyjazd bez
 * wpłat w euro, lejek bez otwartych formularzy, blok demografii bez uczestników.
 * Bez wspólnego strażnika `0/0` wchodzi na pasek i do napisu jako `NaN`.
 *
 * Rozdział na trzy funkcje nie jest ozdobą: **pasek dostaje wartość
 * niezaokrągloną**, bo zaokrąglenie każdego odcinka z osobna rozjeżdża sumę
 * szerokości, a napis dostaje zaokrągloną, bo „58,7%” nikomu nic nie mówi.
 *
 * Obłożenie miejsc ma własny rachunek w `availability.utils.ts` — tam całością
 * jest limit, który może nie istnieć, i to zmienia znaczenie wyniku.
 */

/** Dokładny udział, 0–100 bez zaokrąglenia. `null`, gdy nie ma przez co dzielić. */
export const share = (part: number, total: number): number | null => {
  if (total <= 0) return null;
  return (part / total) * 100;
};

/**
 * Udział gotowy na pasek: nigdy poza torem, zero przy braku całości.
 * Nadpłata albo przekroczony budżet zostają przycięte do pełnej szerokości,
 * zamiast rozpychać pasek poza kartę.
 */
export const barShare = (part: number, total: number): number => {
  const value = share(part, total);
  if (value === null) return 0;
  return Math.min(100, Math.max(0, value));
};

/** Udział jako napis „59%”. `null`, gdy nie ma czego pokazać. */
export const formatShare = (part: number, total: number): string | null => {
  const value = share(part, total);
  return value === null ? null : `${Math.round(value)}%`;
};
